export default "__VITE_ASSET__BuiW3GwM__"